import React from 'react'

const Container = ({ children, fluid, className, style }) => (
  <div style={style} className={`container${fluid ? '-fluid' : ''}${className ? ` ${className}` : ''}`}>{children}</div>
)

export default Container
